import * as React from 'react';
import { toast } from 'sonner';
import { useT } from '@/i18n';
import { sync } from '@/lib/sync';

/**
 * Service-worker update flow (spec §11): a new version is announced, and activated only after all
 * local draft writes have been flushed to IndexedDB.
 */
export function UpdatePrompt() {
  const t = useT();
  React.useEffect(() => {
    if (!('serviceWorker' in navigator) || import.meta.env.DEV) return;
    let cancelled = false;
    void import('virtual:pwa-register').then(({ registerSW }) => {
      if (cancelled) return;
      const update = registerSW({
        immediate: true,
        onNeedRefresh() {
          toast(t('settings.updateAvailable'), {
            duration: Infinity,
            action: {
              label: t('settings.updateNow'),
              onClick: async () => {
                await sync.flushLocal();
                await sync.syncAll();
                await update(true);
              },
            },
          });
        },
      });
    });
    return () => {
      cancelled = true;
    };
  }, [t]);
  return null;
}
